import { useMutation, useQueryClient } from "@tanstack/react-query";
import { removeDataApi } from "../../api/fetchDataApi";
import { useAppDispatch } from "..";
import { openModal } from "../../Modal/modalSlice";
import { Version } from "../../types";
import { getUserToken } from "../../utils/auth/getUserToken";

export const useRemoveListMutation = () => {
  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ version, listId, deviceId }: { version: Version; listId: string; deviceId: string }) => {
      const token = await getUserToken();
      if (!token) {
        console.error("No token found");
        throw new Error("User token is null");
      }

      return removeDataApi(token, version, listId, deviceId);
    },
    onMutate: () => {
      dispatch(
        openModal({
          title: { key: "modal.listRemove.title" },
          message: { key: "modal.listRemove.message.loading" },
          type: "loading",
        }),
      );
    },
    onSuccess: async (response) => {
      queryClient.setQueryData(["listsData"], response.data);
      if (response.data.conflict) {
        dispatch(
          openModal({
            title: { key: "modal.listRemove.title" },
            message: { key: "modal.listRemove.message.error.conflict" },
            type: "error",
          }),
        );
      } else {
        dispatch(
          openModal({
            title: { key: "modal.listRemove.title" },
            message: {
              key: "modal.listRemove.message.success",
            },
            type: "success",
          }),
        );
      }
    },
    onError: () => {
      dispatch(
        openModal({
          title: { key: "modal.listRemove.title" },
          message: { key: "modal.listRemove.message.error.default" },
          type: "error",
        }),
      );
    },
  });
};
